import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.4",
  d: "M15.48 3H7.52C4.07 3 2 5.06 2 8.52V16.47C2 19.94 4.07 22 7.52 22H15.47C18.93 22 20.99 19.94 20.99 16.48V8.52C21 5.06 18.93 3 15.48 3Z",
  fill: "#546375"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21.0234 2.98028C19.2334 1.18028 17.4834 1.14028 15.6434 2.98028L14.5134 4.10028C14.4134 4.20028 14.3834 4.34028 14.4234 4.47028C15.1234 6.92028 17.0834 8.88028 19.5334 9.58028C19.5634 9.59028 19.6134 9.59028 19.6434 9.59028C19.7434 9.59028 19.8434 9.55028 19.9134 9.48028L21.0234 8.36028C21.9334 7.45028 22.3834 6.58028 22.3834 5.69028C22.3834 4.79028 21.9334 3.90028 21.0234 2.98028Z",
  fill: "#546375"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.8611 10.42C17.5911 10.29 17.3311 10.16 17.0911 10.01C16.8911 9.88997 16.6911 9.75997 16.5011 9.61997C16.3411 9.51997 16.1611 9.36997 15.9811 9.21997C15.9611 9.20997 15.9011 9.15997 15.8211 9.07997C15.5111 8.82997 15.1811 8.48997 14.8711 8.11997C14.8511 8.09997 14.7911 8.03997 14.7411 7.94997C14.6411 7.83997 14.4911 7.64997 14.3611 7.43997C14.2511 7.29997 14.1211 7.09997 14.0011 6.88997C13.8511 6.63997 13.7211 6.38997 13.6011 6.12997C13.4711 5.84997 13.3711 5.58997 13.2811 5.33997L7.90108 10.72C7.55108 11.07 7.21108 11.73 7.14108 12.22L6.71108 15.2C6.62108 15.83 6.79108 16.42 7.18108 16.81C7.51108 17.14 7.96108 17.31 8.46108 17.31C8.57108 17.31 8.68108 17.3 8.79108 17.29L11.7611 16.87C12.2511 16.8 12.9111 16.47 13.2611 16.11L18.6411 10.73C18.3911 10.65 18.1411 10.54 17.8611 10.42Z",
  fill: "#546375"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditSquareIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
}

})